// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react'
import { SectionHeadersProps } from './utils/types.ts'
import SectionHeader from './SectionHeader.tsx'
import {
    // TOP_BUFFER,
    LINE_HEIGHT,
    SIDE_BUFFER,
    TEAM_LOGO_SIZE,
    SECTION_MARGIN,
    HEADER_TEXT_HEIGHT,
} from './utils/constants.ts'
import { useDimensions } from './utils/responsive-dimensions.tsx'

function SectionHeaders(props: SectionHeadersProps) {
    const {
        numPlayers,
        groupedSelects,
        existingTypes,
        maxSliderWidth,
        showTeams,
        currentType,
        isMobile,
    } = props

    const { TOP_BUFFER } = useDimensions()

    let statsSeen = 0

    const typeHeaders = existingTypes.map((type, i) => {
        const headersOffset = i * (SECTION_MARGIN + HEADER_TEXT_HEIGHT)
        const statsOffset = statsSeen * LINE_HEIGHT
        const teamOffset = showTeams ? 0 : -TEAM_LOGO_SIZE

        const yOffset = headersOffset + statsOffset + teamOffset

        const header = (
            <g key={type} transform={`translate(0,${yOffset})`}>
                <SectionHeader
                    key={`${type}_section_header`}
                    type={type}
                    numPlayers={numPlayers}
                    maxSliderWidth={maxSliderWidth}
                    currentType={currentType}
                    isMobile={isMobile}
                    onlyArsenal={
                        existingTypes.length === 1 && type === 'pitch_arsenal'
                    }
                />
            </g>
        )

        statsSeen += groupedSelects[type].length

        return header
    })

    return (
        <g transform={`translate(${SIDE_BUFFER},${TOP_BUFFER})`}>
            {typeHeaders}
        </g>
    )
}

export default SectionHeaders
